var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrowPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.420871 18.5783C0.975101 19.1406 1.87365 19.1406 2.42802 18.5783L9.36466 11.5344C10.4723 10.4096 10.4718 8.58705 9.36368 7.46298L2.42291 0.421687C1.86854 -0.140563 0.969993 -0.140563 0.415621 0.421687C-0.138609 0.983935 -0.138609 1.89563 0.41562 2.45788L6.35632 8.48454C6.91058 9.04679 6.91058 9.95834 6.35632 10.5207L0.420871 16.5421C-0.133501 17.1043 -0.133501 18.016 0.420871 18.5783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrowPagination);
export default __webpack_public_path__ + "static/media/RightarrowPagination.1914d1b65dbc4f5dc2b11180e5931e94.svg";
export { ForwardRef as ReactComponent };